import moment from "moment";
import React from "react";
import {
    loadFont,
    marketingCreativeColorSchemes,
    marketingCreativeTemplateKeys,
} from "ui/pages/marketing/MarketingCreatives/data";
import { handleDateFormat } from "utils/Utils";

export const ColvenPostDetailed = (props) => {
    const { textData, coverImage } = props;

    const defaultColorScheme =
        marketingCreativeColorSchemes?.[marketingCreativeTemplateKeys.Colven]
            ?.schemes?.[0];

    const color1 = props?.colors?.[0] || defaultColorScheme?.[0];
    const color2 = props?.colors?.[1] || defaultColorScheme?.[1];
    const color3 = props?.colors?.[2] || defaultColorScheme?.[2];
    const color4 = props?.colors?.[3] || defaultColorScheme?.[3];

    const startDateExists = textData?.start_date_time?.exists;
    const startDate = startDateExists && textData?.start_date_time?.date;
    const startTime = startDateExists && textData?.start_date_time?.time;
    const endDateExists = textData?.end_date_time?.exists;
    const endDate = endDateExists && textData?.end_date_time?.date;
    const endTime = endDateExists && textData?.end_date_time?.time;

    React.useEffect(() => {
        loadFont(
            "https://fonts.googleapis.com/css2?family=Montserrat&display=swap"
        );
    }, []);

    return (
        <div style={{ fontFamily: "Montserrat" }}>
            {textData?.heading ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        top: "70px",
                        left: "26px",
                        fontWeight: 800,
                        fontSize: "72px",
                        width: "876px",
                        wordBreak: "break-word",
                        textTransform: "uppercase",
                    }}
                >
                    {textData?.heading}
                </div>
            ) : null}
            {textData?.sub_heading ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        top: "271px",
                        left: "26px",
                        fontWeight: 600,
                        fontSize: "40px",
                        width: "925px",
                        wordBreak: "break-word",
                    }}
                >
                    {textData?.sub_heading}
                </div>
            ) : null}
            {startDate ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        top: "370px",
                        left: "23px",
                        fontWeight: 800,
                        fontSize: "48px",
                        width: "876px",
                        height: "117px",
                        backgroundColor: color3,
                        whiteSpace: "nowrap",
                    }}
                >
                    <svg
                        width="53"
                        height="53"
                        style={{
                            position: "absolute",
                            top: "30px",
                            left: "31px",
                        }}
                        viewBox="0 0 53 53"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="3"
                            y="10.8333"
                            width="47"
                            height="39.1667"
                            rx="2"
                            stroke={color2}
                            stroke-width="6"
                        />
                        <path
                            d="M3 23.8889L50 23.8889"
                            stroke={color2}
                            stroke-width="6"
                            stroke-linecap="round"
                        />
                        <path
                            d="M18.6689 36.9441H34.3356"
                            stroke={color2}
                            stroke-width="6"
                            stroke-linecap="round"
                        />
                        <path
                            d="M16.0557 3L16.0557 13.4444"
                            stroke={color2}
                            stroke-width="6"
                            stroke-linecap="round"
                        />
                        <path
                            d="M36.9443 3L36.9443 13.4444"
                            stroke={color2}
                            stroke-width="6"
                            stroke-linecap="round"
                        />
                    </svg>

                    <div
                        style={{
                            position: "absolute",
                            left: "126px",
                            height: "117px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        {endDate ? (
                            <>
                                <div>{handleDateFormat(startDate, false)}</div>
                                <div>{handleDateFormat(endDate, false)}</div>
                            </>
                        ) : (
                            <div>{handleDateFormat(startDate, false)}</div>
                        )}
                    </div>
                    {startTime ? (
                        <>
                            <svg
                                style={{
                                    position: "absolute",
                                    top: "34px",
                                    left: "557px",
                                }}
                                width="53"
                                height="53"
                                viewBox="0 0 53 53"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="26.5"
                                    cy="26.5"
                                    r="23"
                                    stroke={color2}
                                    stroke-width="7"
                                />
                                <path
                                    d="M37.7277 27.0905H27.3413C27.2032 27.0905 27.0913 26.9786 27.0913 26.8405V17.636"
                                    stroke={color2}
                                    stroke-width="7"
                                    stroke-linecap="round"
                                />
                            </svg>
                            <div
                                style={{
                                    position: "absolute",
                                    left: "652px",
                                    height: "118px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                }}
                            >
                                {startTime ? <div>{startTime}</div> : null}
                                {endTime ? <div>{endTime}</div> : null}
                            </div>
                        </>
                    ) : null}
                    <svg
                        width="77"
                        height="35"
                        style={{
                            top: "125px",
                            left: "787px",
                            position: "absolute",
                        }}
                        viewBox="0 0 77 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M54.6959 34.6674C53.8469 34.1708 53.7486 33.2986 54.4763 32.7193L72.4634 18.3991C73.1133 17.8817 73.1133 17.1183 72.4634 16.6009L54.4763 2.28072C53.7486 1.70139 53.8469 0.829201 54.6959 0.33263C55.5449 -0.163937 56.823 -0.0968475 57.5507 0.482483L75.5378 14.8026C77.4874 16.3548 77.4874 18.6452 75.5378 20.1974L57.5507 34.5175C56.823 35.0968 55.5449 35.1639 54.6959 34.6674ZM27.7015 34.6674C26.8525 34.1708 26.7542 33.2986 27.4819 32.7193L45.469 18.3991C46.1189 17.8817 46.1189 17.1183 45.469 16.6009L27.4819 2.28072C26.7542 1.70139 26.8525 0.829201 27.7015 0.33263C28.5504 -0.163937 29.8286 -0.0968475 30.5562 0.482483L48.5433 14.8026C50.493 16.3548 50.493 18.6452 48.5434 20.1974L30.5562 34.5175C29.8286 35.0968 28.5504 35.1639 27.7015 34.6674ZM0.487442 32.7193C-0.240234 33.2986 -0.141922 34.1708 0.707039 34.6674C1.556 35.1639 2.83411 35.0968 3.5618 34.5175L21.5489 20.1974C23.4985 18.6452 23.4985 16.3548 21.5489 14.8026L3.5618 0.482483C2.83412 -0.0968475 1.556 -0.163937 0.707039 0.33263C-0.141922 0.829201 -0.240234 1.70139 0.487442 2.28072L18.4746 16.6009C19.1244 17.1183 19.1244 17.8817 18.4746 18.3991L0.487442 32.7193Z"
                            fill={color2}
                        />
                    </svg>
                </div>
            ) : null}
            {textData?.action_text ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        backgroundColor: color3,
                        bottom: "0px",
                        left: "0px",
                        paddingLeft: "26px",
                        paddingRight: "26px",
                        wordBreak: "break-word",
                        height: "201px",
                        width: "411px",
                        fontWeight: 800,
                        fontSize: "64px",
                        textTransform: "uppercase",
                    }}
                >
                    {textData?.action_text}
                    <svg
                        width="130"
                        height="30"
                        style={{
                            position: "absolute",
                            top: "157px",
                            left: "326px",
                        }}
                        viewBox="0 0 130 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5 27.5C5 26.1193 3.88071 25 2.5 25C1.11929 25 0 26.1193 0 27.5C0 28.8807 1.11929 30 2.5 30C3.88071 30 5 28.8807 5 27.5ZM30 27.5C30 26.1193 28.8807 25 27.5 25C26.1193 25 25 26.1193 25 27.5C25 28.8807 26.1193 30 27.5 30C28.8807 30 30 28.8807 30 27.5ZM52.5 25C53.8807 25 55 26.1193 55 27.5C55 28.8807 53.8807 30 52.5 30C51.1193 30 50 28.8807 50 27.5C50 26.1193 51.1193 25 52.5 25ZM80 27.5C80 26.1193 78.8807 25 77.5 25C76.1193 25 75 26.1193 75 27.5C75 28.8807 76.1193 30 77.5 30C78.8807 30 80 28.8807 80 27.5ZM102.5 25C103.881 25 105 26.1193 105 27.5C105 28.8807 103.881 30 102.5 30C101.119 30 100 28.8807 100 27.5C100 26.1193 101.119 25 102.5 25ZM130 27.5C130 26.1193 128.881 25 127.5 25C126.119 25 125 26.1193 125 27.5C125 28.8807 126.119 30 127.5 30C128.881 30 130 28.8807 130 27.5ZM2.5 0C3.88071 0 5 1.11929 5 2.5C5 3.88071 3.88071 5 2.5 5C1.11929 5 0 3.88071 0 2.5C0 1.11929 1.11929 0 2.5 0ZM30 2.5C30 1.11929 28.8807 0 27.5 0C26.1193 0 25 1.11929 25 2.5C25 3.88071 26.1193 5 27.5 5C28.8807 5 30 3.88071 30 2.5ZM52.5 0C53.8807 0 55 1.11929 55 2.5C55 3.88071 53.8807 5 52.5 5C51.1193 5 50 3.88071 50 2.5C50 1.11929 51.1193 0 52.5 0ZM80 2.5C80 1.11929 78.8807 0 77.5 0C76.1193 0 75 1.11929 75 2.5C75 3.88071 76.1193 5 77.5 5C78.8807 5 80 3.88071 80 2.5ZM102.5 0C103.881 0 105 1.11929 105 2.5C105 3.88071 103.881 5 102.5 5C101.119 5 100 3.88071 100 2.5C100 1.11929 101.119 0 102.5 0ZM130 2.5C130 1.11929 128.881 0 127.5 0C126.119 0 125 1.11929 125 2.5C125 3.88071 126.119 5 127.5 5C128.881 5 130 3.88071 130 2.5Z"
                            fill={color4}
                        />
                    </svg>
                </div>
            ) : null}
            {textData?.additional_text ? (
                <div
                    style={{
                        position: "absolute",
                        color: color2,
                        bottom: "59px",
                        right: "30px",
                        fontWeight: 500,
                        fontSize: "24px",
                        writingMode: "vertical-rl",
                        transform: "rotate(180deg)",
                        whiteSpace: "nowrap",
                    }}
                >
                    {textData?.additional_text}
                </div>
            ) : null}
            {coverImage ? (
                <div
                    style={{
                        position: "absolute",
                        width: "396.02px",
                        height: "496px",
                        top: "540px",
                        left: "557px",
                        backgroundImage: "url(" + coverImage + ")",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}
                />
            ) : null}
            {textData?.details_list?.title ? (
                <div
                    style={{
                        position: "absolute",
                        color: color4,
                        top: "530px",
                        left: "26px",
                        fontWeight: 800,
                        fontSize: "36px",
                        whiteSpace: "nowrap",
                    }}
                >
                    {textData?.details_list?.title}
                </div>
            ) : null}
            {textData?.details_list?.data ? (
                <div
                    style={{
                        position: "absolute",
                        color: color4,
                        top: "599px",
                        left: "26px",
                        fontWeight: 400,
                        fontSize: "36px",
                        whiteSpace: "nowrap",
                        zIndex: 1,
                    }}
                >
                    {textData?.details_list?.data?.map((item) => (
                        <div>{item}</div>
                    ))}
                </div>
            ) : null}

            <svg
                width="397"
                height="496"
                style={{
                    position: "absolute",
                    top: "540px",
                    left: "557px",
                }}
                viewBox="0 0 397 496"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_19_5)">
                    <line
                        x1="-42.3081"
                        y1="224.755"
                        x2="115.818"
                        y2="36.3081"
                        stroke={color2}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <g clip-path="url(#clip1_19_5)">
                        <rect
                            width="527"
                            height="764"
                            fill={color1}
                            fill-opacity="0.25"
                        />
                        <line
                            x1="-42.3081"
                            y1="224.755"
                            x2="115.818"
                            y2="36.3081"
                            stroke={color2}
                            stroke-width="5"
                            stroke-linecap="round"
                        />
                        <line
                            x1="181.692"
                            y1="570.755"
                            x2="339.818"
                            y2="382.308"
                            stroke={color2}
                            stroke-width="5"
                            stroke-linecap="round"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_19_5">
                        <rect width="396.02" height="496" fill={color4} />
                    </clipPath>
                    <clipPath id="clip1_19_5">
                        <rect width="527" height="764" fill={color4} />
                    </clipPath>
                </defs>
            </svg>

            <svg
                width="1080"
                height="1080"
                viewBox="0 0 1080 1080"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clip-path="url(#clip0_689_1900)">
                    <rect width="1080" height="1080" fill={color1} />
                    <path
                        d="M904 34.5C904 35.8807 902.881 37 901.5 37C900.119 37 899 35.8807 899 34.5C899 33.1193 900.119 32 901.5 32C902.881 32 904 33.1193 904 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 34.5C919 35.8807 917.881 37 916.5 37C915.119 37 914 35.8807 914 34.5C914 33.1193 915.119 32 916.5 32C917.881 32 919 33.1193 919 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 34.5C934 35.8807 932.881 37 931.5 37C930.119 37 929 35.8807 929 34.5C929 33.1193 930.119 32 931.5 32C932.881 32 934 33.1193 934 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 34.5C949 35.8807 947.881 37 946.5 37C945.119 37 944 35.8807 944 34.5C944 33.1193 945.119 32 946.5 32C947.881 32 949 33.1193 949 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 34.5C964 35.8807 962.881 37 961.5 37C960.119 37 959 35.8807 959 34.5C959 33.1193 960.119 32 961.5 32C962.881 32 964 33.1193 964 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 34.5C979 35.8807 977.881 37 976.5 37C975.119 37 974 35.8807 974 34.5C974 33.1193 975.119 32 976.5 32C977.881 32 979 33.1193 979 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 34.5C994 35.8807 992.881 37 991.5 37C990.119 37 989 35.8807 989 34.5C989 33.1193 990.119 32 991.5 32C992.881 32 994 33.1193 994 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 34.5C1009 35.8807 1007.88 37 1006.5 37C1005.12 37 1004 35.8807 1004 34.5C1004 33.1193 1005.12 32 1006.5 32C1007.88 32 1009 33.1193 1009 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 34.5C1024 35.8807 1022.88 37 1021.5 37C1020.12 37 1019 35.8807 1019 34.5C1019 33.1193 1020.12 32 1021.5 32C1022.88 32 1024 33.1193 1024 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 34.5C1039 35.8807 1037.88 37 1036.5 37C1035.12 37 1034 35.8807 1034 34.5C1034 33.1193 1035.12 32 1036.5 32C1037.88 32 1039 33.1193 1039 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 34.5C1054 35.8807 1052.88 37 1051.5 37C1050.12 37 1049 35.8807 1049 34.5C1049 33.1193 1050.12 32 1051.5 32C1052.88 32 1054 33.1193 1054 34.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 49.5C904 50.8807 902.881 52 901.5 52C900.119 52 899 50.8807 899 49.5C899 48.1193 900.119 47 901.5 47C902.881 47 904 48.1193 904 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 49.5C919 50.8807 917.881 52 916.5 52C915.119 52 914 50.8807 914 49.5C914 48.1193 915.119 47 916.5 47C917.881 47 919 48.1193 919 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 49.5C934 50.8807 932.881 52 931.5 52C930.119 52 929 50.8807 929 49.5C929 48.1193 930.119 47 931.5 47C932.881 47 934 48.1193 934 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 49.5C949 50.8807 947.881 52 946.5 52C945.119 52 944 50.8807 944 49.5C944 48.1193 945.119 47 946.5 47C947.881 47 949 48.1193 949 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 49.5C964 50.8807 962.881 52 961.5 52C960.119 52 959 50.8807 959 49.5C959 48.1193 960.119 47 961.5 47C962.881 47 964 48.1193 964 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 49.5C979 50.8807 977.881 52 976.5 52C975.119 52 974 50.8807 974 49.5C974 48.1193 975.119 47 976.5 47C977.881 47 979 48.1193 979 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 49.5C994 50.8807 992.881 52 991.5 52C990.119 52 989 50.8807 989 49.5C989 48.1193 990.119 47 991.5 47C992.881 47 994 48.1193 994 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 49.5C1009 50.8807 1007.88 52 1006.5 52C1005.12 52 1004 50.8807 1004 49.5C1004 48.1193 1005.12 47 1006.5 47C1007.88 47 1009 48.1193 1009 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 49.5C1024 50.8807 1022.88 52 1021.5 52C1020.12 52 1019 50.8807 1019 49.5C1019 48.1193 1020.12 47 1021.5 47C1022.88 47 1024 48.1193 1024 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 49.5C1039 50.8807 1037.88 52 1036.5 52C1035.12 52 1034 50.8807 1034 49.5C1034 48.1193 1035.12 47 1036.5 47C1037.88 47 1039 48.1193 1039 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 49.5C1054 50.8807 1052.88 52 1051.5 52C1050.12 52 1049 50.8807 1049 49.5C1049 48.1193 1050.12 47 1051.5 47C1052.88 47 1054 48.1193 1054 49.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 64.5C904 65.8807 902.881 67 901.5 67C900.119 67 899 65.8807 899 64.5C899 63.1193 900.119 62 901.5 62C902.881 62 904 63.1193 904 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 64.5C919 65.8807 917.881 67 916.5 67C915.119 67 914 65.8807 914 64.5C914 63.1193 915.119 62 916.5 62C917.881 62 919 63.1193 919 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 64.5C934 65.8807 932.881 67 931.5 67C930.119 67 929 65.8807 929 64.5C929 63.1193 930.119 62 931.5 62C932.881 62 934 63.1193 934 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 64.5C949 65.8807 947.881 67 946.5 67C945.119 67 944 65.8807 944 64.5C944 63.1193 945.119 62 946.5 62C947.881 62 949 63.1193 949 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 64.5C964 65.8807 962.881 67 961.5 67C960.119 67 959 65.8807 959 64.5C959 63.1193 960.119 62 961.5 62C962.881 62 964 63.1193 964 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 64.5C979 65.8807 977.881 67 976.5 67C975.119 67 974 65.8807 974 64.5C974 63.1193 975.119 62 976.5 62C977.881 62 979 63.1193 979 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 64.5C994 65.8807 992.881 67 991.5 67C990.119 67 989 65.8807 989 64.5C989 63.1193 990.119 62 991.5 62C992.881 62 994 63.1193 994 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 64.5C1009 65.8807 1007.88 67 1006.5 67C1005.12 67 1004 65.8807 1004 64.5C1004 63.1193 1005.12 62 1006.5 62C1007.88 62 1009 63.1193 1009 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 64.5C1024 65.8807 1022.88 67 1021.5 67C1020.12 67 1019 65.8807 1019 64.5C1019 63.1193 1020.12 62 1021.5 62C1022.88 62 1024 63.1193 1024 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 64.5C1039 65.8807 1037.88 67 1036.5 67C1035.12 67 1034 65.8807 1034 64.5C1034 63.1193 1035.12 62 1036.5 62C1037.88 62 1039 63.1193 1039 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 64.5C1054 65.8807 1052.88 67 1051.5 67C1050.12 67 1049 65.8807 1049 64.5C1049 63.1193 1050.12 62 1051.5 62C1052.88 62 1054 63.1193 1054 64.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 79.5C904 80.8807 902.881 82 901.5 82C900.119 82 899 80.8807 899 79.5C899 78.1193 900.119 77 901.5 77C902.881 77 904 78.1193 904 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 79.5C919 80.8807 917.881 82 916.5 82C915.119 82 914 80.8807 914 79.5C914 78.1193 915.119 77 916.5 77C917.881 77 919 78.1193 919 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 79.5C934 80.8807 932.881 82 931.5 82C930.119 82 929 80.8807 929 79.5C929 78.1193 930.119 77 931.5 77C932.881 77 934 78.1193 934 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 79.5C949 80.8807 947.881 82 946.5 82C945.119 82 944 80.8807 944 79.5C944 78.1193 945.119 77 946.5 77C947.881 77 949 78.1193 949 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 79.5C964 80.8807 962.881 82 961.5 82C960.119 82 959 80.8807 959 79.5C959 78.1193 960.119 77 961.5 77C962.881 77 964 78.1193 964 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 79.5C979 80.8807 977.881 82 976.5 82C975.119 82 974 80.8807 974 79.5C974 78.1193 975.119 77 976.5 77C977.881 77 979 78.1193 979 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 79.5C994 80.8807 992.881 82 991.5 82C990.119 82 989 80.8807 989 79.5C989 78.1193 990.119 77 991.5 77C992.881 77 994 78.1193 994 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 79.5C1009 80.8807 1007.88 82 1006.5 82C1005.12 82 1004 80.8807 1004 79.5C1004 78.1193 1005.12 77 1006.5 77C1007.88 77 1009 78.1193 1009 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 79.5C1024 80.8807 1022.88 82 1021.5 82C1020.12 82 1019 80.8807 1019 79.5C1019 78.1193 1020.12 77 1021.5 77C1022.88 77 1024 78.1193 1024 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 79.5C1039 80.8807 1037.88 82 1036.5 82C1035.12 82 1034 80.8807 1034 79.5C1034 78.1193 1035.12 77 1036.5 77C1037.88 77 1039 78.1193 1039 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 79.5C1054 80.8807 1052.88 82 1051.5 82C1050.12 82 1049 80.8807 1049 79.5C1049 78.1193 1050.12 77 1051.5 77C1052.88 77 1054 78.1193 1054 79.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 94.5C904 95.8807 902.881 97 901.5 97C900.119 97 899 95.8807 899 94.5C899 93.1193 900.119 92 901.5 92C902.881 92 904 93.1193 904 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 94.5C919 95.8807 917.881 97 916.5 97C915.119 97 914 95.8807 914 94.5C914 93.1193 915.119 92 916.5 92C917.881 92 919 93.1193 919 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 94.5C934 95.8807 932.881 97 931.5 97C930.119 97 929 95.8807 929 94.5C929 93.1193 930.119 92 931.5 92C932.881 92 934 93.1193 934 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 94.5C949 95.8807 947.881 97 946.5 97C945.119 97 944 95.8807 944 94.5C944 93.1193 945.119 92 946.5 92C947.881 92 949 93.1193 949 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 94.5C964 95.8807 962.881 97 961.5 97C960.119 97 959 95.8807 959 94.5C959 93.1193 960.119 92 961.5 92C962.881 92 964 93.1193 964 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 94.5C979 95.8807 977.881 97 976.5 97C975.119 97 974 95.8807 974 94.5C974 93.1193 975.119 92 976.5 92C977.881 92 979 93.1193 979 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 94.5C994 95.8807 992.881 97 991.5 97C990.119 97 989 95.8807 989 94.5C989 93.1193 990.119 92 991.5 92C992.881 92 994 93.1193 994 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 94.5C1009 95.8807 1007.88 97 1006.5 97C1005.12 97 1004 95.8807 1004 94.5C1004 93.1193 1005.12 92 1006.5 92C1007.88 92 1009 93.1193 1009 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 94.5C1024 95.8807 1022.88 97 1021.5 97C1020.12 97 1019 95.8807 1019 94.5C1019 93.1193 1020.12 92 1021.5 92C1022.88 92 1024 93.1193 1024 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 94.5C1039 95.8807 1037.88 97 1036.5 97C1035.12 97 1034 95.8807 1034 94.5C1034 93.1193 1035.12 92 1036.5 92C1037.88 92 1039 93.1193 1039 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 94.5C1054 95.8807 1052.88 97 1051.5 97C1050.12 97 1049 95.8807 1049 94.5C1049 93.1193 1050.12 92 1051.5 92C1052.88 92 1054 93.1193 1054 94.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 109.5C904 110.881 902.881 112 901.5 112C900.119 112 899 110.881 899 109.5C899 108.119 900.119 107 901.5 107C902.881 107 904 108.119 904 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 109.5C919 110.881 917.881 112 916.5 112C915.119 112 914 110.881 914 109.5C914 108.119 915.119 107 916.5 107C917.881 107 919 108.119 919 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 109.5C934 110.881 932.881 112 931.5 112C930.119 112 929 110.881 929 109.5C929 108.119 930.119 107 931.5 107C932.881 107 934 108.119 934 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 109.5C949 110.881 947.881 112 946.5 112C945.119 112 944 110.881 944 109.5C944 108.119 945.119 107 946.5 107C947.881 107 949 108.119 949 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 109.5C964 110.881 962.881 112 961.5 112C960.119 112 959 110.881 959 109.5C959 108.119 960.119 107 961.5 107C962.881 107 964 108.119 964 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 109.5C979 110.881 977.881 112 976.5 112C975.119 112 974 110.881 974 109.5C974 108.119 975.119 107 976.5 107C977.881 107 979 108.119 979 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 109.5C994 110.881 992.881 112 991.5 112C990.119 112 989 110.881 989 109.5C989 108.119 990.119 107 991.5 107C992.881 107 994 108.119 994 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 109.5C1009 110.881 1007.88 112 1006.5 112C1005.12 112 1004 110.881 1004 109.5C1004 108.119 1005.12 107 1006.5 107C1007.88 107 1009 108.119 1009 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 109.5C1024 110.881 1022.88 112 1021.5 112C1020.12 112 1019 110.881 1019 109.5C1019 108.119 1020.12 107 1021.5 107C1022.88 107 1024 108.119 1024 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 109.5C1039 110.881 1037.88 112 1036.5 112C1035.12 112 1034 110.881 1034 109.5C1034 108.119 1035.12 107 1036.5 107C1037.88 107 1039 108.119 1039 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 109.5C1054 110.881 1052.88 112 1051.5 112C1050.12 112 1049 110.881 1049 109.5C1049 108.119 1050.12 107 1051.5 107C1052.88 107 1054 108.119 1054 109.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 124.5C904 125.881 902.881 127 901.5 127C900.119 127 899 125.881 899 124.5C899 123.119 900.119 122 901.5 122C902.881 122 904 123.119 904 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 124.5C919 125.881 917.881 127 916.5 127C915.119 127 914 125.881 914 124.5C914 123.119 915.119 122 916.5 122C917.881 122 919 123.119 919 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 124.5C934 125.881 932.881 127 931.5 127C930.119 127 929 125.881 929 124.5C929 123.119 930.119 122 931.5 122C932.881 122 934 123.119 934 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 124.5C949 125.881 947.881 127 946.5 127C945.119 127 944 125.881 944 124.5C944 123.119 945.119 122 946.5 122C947.881 122 949 123.119 949 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 124.5C964 125.881 962.881 127 961.5 127C960.119 127 959 125.881 959 124.5C959 123.119 960.119 122 961.5 122C962.881 122 964 123.119 964 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 124.5C979 125.881 977.881 127 976.5 127C975.119 127 974 125.881 974 124.5C974 123.119 975.119 122 976.5 122C977.881 122 979 123.119 979 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 124.5C994 125.881 992.881 127 991.5 127C990.119 127 989 125.881 989 124.5C989 123.119 990.119 122 991.5 122C992.881 122 994 123.119 994 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 124.5C1009 125.881 1007.88 127 1006.5 127C1005.12 127 1004 125.881 1004 124.5C1004 123.119 1005.12 122 1006.5 122C1007.88 122 1009 123.119 1009 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 124.5C1024 125.881 1022.88 127 1021.5 127C1020.12 127 1019 125.881 1019 124.5C1019 123.119 1020.12 122 1021.5 122C1022.88 122 1024 123.119 1024 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 124.5C1039 125.881 1037.88 127 1036.5 127C1035.12 127 1034 125.881 1034 124.5C1034 123.119 1035.12 122 1036.5 122C1037.88 122 1039 123.119 1039 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 124.5C1054 125.881 1052.88 127 1051.5 127C1050.12 127 1049 125.881 1049 124.5C1049 123.119 1050.12 122 1051.5 122C1052.88 122 1054 123.119 1054 124.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 139.5C904 140.881 902.881 142 901.5 142C900.119 142 899 140.881 899 139.5C899 138.119 900.119 137 901.5 137C902.881 137 904 138.119 904 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 139.5C919 140.881 917.881 142 916.5 142C915.119 142 914 140.881 914 139.5C914 138.119 915.119 137 916.5 137C917.881 137 919 138.119 919 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 139.5C934 140.881 932.881 142 931.5 142C930.119 142 929 140.881 929 139.5C929 138.119 930.119 137 931.5 137C932.881 137 934 138.119 934 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 139.5C949 140.881 947.881 142 946.5 142C945.119 142 944 140.881 944 139.5C944 138.119 945.119 137 946.5 137C947.881 137 949 138.119 949 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 139.5C964 140.881 962.881 142 961.5 142C960.119 142 959 140.881 959 139.5C959 138.119 960.119 137 961.5 137C962.881 137 964 138.119 964 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 139.5C979 140.881 977.881 142 976.5 142C975.119 142 974 140.881 974 139.5C974 138.119 975.119 137 976.5 137C977.881 137 979 138.119 979 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 139.5C994 140.881 992.881 142 991.5 142C990.119 142 989 140.881 989 139.5C989 138.119 990.119 137 991.5 137C992.881 137 994 138.119 994 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 139.5C1009 140.881 1007.88 142 1006.5 142C1005.12 142 1004 140.881 1004 139.5C1004 138.119 1005.12 137 1006.5 137C1007.88 137 1009 138.119 1009 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 139.5C1024 140.881 1022.88 142 1021.5 142C1020.12 142 1019 140.881 1019 139.5C1019 138.119 1020.12 137 1021.5 137C1022.88 137 1024 138.119 1024 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 139.5C1039 140.881 1037.88 142 1036.5 142C1035.12 142 1034 140.881 1034 139.5C1034 138.119 1035.12 137 1036.5 137C1037.88 137 1039 138.119 1039 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 139.5C1054 140.881 1052.88 142 1051.5 142C1050.12 142 1049 140.881 1049 139.5C1049 138.119 1050.12 137 1051.5 137C1052.88 137 1054 138.119 1054 139.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 154.5C904 155.881 902.881 157 901.5 157C900.119 157 899 155.881 899 154.5C899 153.119 900.119 152 901.5 152C902.881 152 904 153.119 904 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 154.5C919 155.881 917.881 157 916.5 157C915.119 157 914 155.881 914 154.5C914 153.119 915.119 152 916.5 152C917.881 152 919 153.119 919 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 154.5C934 155.881 932.881 157 931.5 157C930.119 157 929 155.881 929 154.5C929 153.119 930.119 152 931.5 152C932.881 152 934 153.119 934 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 154.5C949 155.881 947.881 157 946.5 157C945.119 157 944 155.881 944 154.5C944 153.119 945.119 152 946.5 152C947.881 152 949 153.119 949 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 154.5C964 155.881 962.881 157 961.5 157C960.119 157 959 155.881 959 154.5C959 153.119 960.119 152 961.5 152C962.881 152 964 153.119 964 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 154.5C979 155.881 977.881 157 976.5 157C975.119 157 974 155.881 974 154.5C974 153.119 975.119 152 976.5 152C977.881 152 979 153.119 979 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 154.5C994 155.881 992.881 157 991.5 157C990.119 157 989 155.881 989 154.5C989 153.119 990.119 152 991.5 152C992.881 152 994 153.119 994 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 154.5C1009 155.881 1007.88 157 1006.5 157C1005.12 157 1004 155.881 1004 154.5C1004 153.119 1005.12 152 1006.5 152C1007.88 152 1009 153.119 1009 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 154.5C1024 155.881 1022.88 157 1021.5 157C1020.12 157 1019 155.881 1019 154.5C1019 153.119 1020.12 152 1021.5 152C1022.88 152 1024 153.119 1024 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 154.5C1039 155.881 1037.88 157 1036.5 157C1035.12 157 1034 155.881 1034 154.5C1034 153.119 1035.12 152 1036.5 152C1037.88 152 1039 153.119 1039 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 154.5C1054 155.881 1052.88 157 1051.5 157C1050.12 157 1049 155.881 1049 154.5C1049 153.119 1050.12 152 1051.5 152C1052.88 152 1054 153.119 1054 154.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 169.5C904 170.881 902.881 172 901.5 172C900.119 172 899 170.881 899 169.5C899 168.119 900.119 167 901.5 167C902.881 167 904 168.119 904 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 169.5C919 170.881 917.881 172 916.5 172C915.119 172 914 170.881 914 169.5C914 168.119 915.119 167 916.5 167C917.881 167 919 168.119 919 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 169.5C934 170.881 932.881 172 931.5 172C930.119 172 929 170.881 929 169.5C929 168.119 930.119 167 931.5 167C932.881 167 934 168.119 934 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 169.5C949 170.881 947.881 172 946.5 172C945.119 172 944 170.881 944 169.5C944 168.119 945.119 167 946.5 167C947.881 167 949 168.119 949 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 169.5C964 170.881 962.881 172 961.5 172C960.119 172 959 170.881 959 169.5C959 168.119 960.119 167 961.5 167C962.881 167 964 168.119 964 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 169.5C979 170.881 977.881 172 976.5 172C975.119 172 974 170.881 974 169.5C974 168.119 975.119 167 976.5 167C977.881 167 979 168.119 979 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 169.5C994 170.881 992.881 172 991.5 172C990.119 172 989 170.881 989 169.5C989 168.119 990.119 167 991.5 167C992.881 167 994 168.119 994 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 169.5C1009 170.881 1007.88 172 1006.5 172C1005.12 172 1004 170.881 1004 169.5C1004 168.119 1005.12 167 1006.5 167C1007.88 167 1009 168.119 1009 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 169.5C1024 170.881 1022.88 172 1021.5 172C1020.12 172 1019 170.881 1019 169.5C1019 168.119 1020.12 167 1021.5 167C1022.88 167 1024 168.119 1024 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 169.5C1039 170.881 1037.88 172 1036.5 172C1035.12 172 1034 170.881 1034 169.5C1034 168.119 1035.12 167 1036.5 167C1037.88 167 1039 168.119 1039 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 169.5C1054 170.881 1052.88 172 1051.5 172C1050.12 172 1049 170.881 1049 169.5C1049 168.119 1050.12 167 1051.5 167C1052.88 167 1054 168.119 1054 169.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 184.5C904 185.881 902.881 187 901.5 187C900.119 187 899 185.881 899 184.5C899 183.119 900.119 182 901.5 182C902.881 182 904 183.119 904 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 184.5C919 185.881 917.881 187 916.5 187C915.119 187 914 185.881 914 184.5C914 183.119 915.119 182 916.5 182C917.881 182 919 183.119 919 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 184.5C934 185.881 932.881 187 931.5 187C930.119 187 929 185.881 929 184.5C929 183.119 930.119 182 931.5 182C932.881 182 934 183.119 934 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 184.5C949 185.881 947.881 187 946.5 187C945.119 187 944 185.881 944 184.5C944 183.119 945.119 182 946.5 182C947.881 182 949 183.119 949 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 184.5C964 185.881 962.881 187 961.5 187C960.119 187 959 185.881 959 184.5C959 183.119 960.119 182 961.5 182C962.881 182 964 183.119 964 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 184.5C979 185.881 977.881 187 976.5 187C975.119 187 974 185.881 974 184.5C974 183.119 975.119 182 976.5 182C977.881 182 979 183.119 979 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 184.5C994 185.881 992.881 187 991.5 187C990.119 187 989 185.881 989 184.5C989 183.119 990.119 182 991.5 182C992.881 182 994 183.119 994 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 184.5C1009 185.881 1007.88 187 1006.5 187C1005.12 187 1004 185.881 1004 184.5C1004 183.119 1005.12 182 1006.5 182C1007.88 182 1009 183.119 1009 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 184.5C1024 185.881 1022.88 187 1021.5 187C1020.12 187 1019 185.881 1019 184.5C1019 183.119 1020.12 182 1021.5 182C1022.88 182 1024 183.119 1024 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 184.5C1039 185.881 1037.88 187 1036.5 187C1035.12 187 1034 185.881 1034 184.5C1034 183.119 1035.12 182 1036.5 182C1037.88 182 1039 183.119 1039 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 184.5C1054 185.881 1052.88 187 1051.5 187C1050.12 187 1049 185.881 1049 184.5C1049 183.119 1050.12 182 1051.5 182C1052.88 182 1054 183.119 1054 184.5Z"
                        fill={color2}
                    />
                    <path
                        d="M904 199.5C904 200.881 902.881 202 901.5 202C900.119 202 899 200.881 899 199.5C899 198.119 900.119 197 901.5 197C902.881 197 904 198.119 904 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M919 199.5C919 200.881 917.881 202 916.5 202C915.119 202 914 200.881 914 199.5C914 198.119 915.119 197 916.5 197C917.881 197 919 198.119 919 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M934 199.5C934 200.881 932.881 202 931.5 202C930.119 202 929 200.881 929 199.5C929 198.119 930.119 197 931.5 197C932.881 197 934 198.119 934 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M949 199.5C949 200.881 947.881 202 946.5 202C945.119 202 944 200.881 944 199.5C944 198.119 945.119 197 946.5 197C947.881 197 949 198.119 949 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M964 199.5C964 200.881 962.881 202 961.5 202C960.119 202 959 200.881 959 199.5C959 198.119 960.119 197 961.5 197C962.881 197 964 198.119 964 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M979 199.5C979 200.881 977.881 202 976.5 202C975.119 202 974 200.881 974 199.5C974 198.119 975.119 197 976.5 197C977.881 197 979 198.119 979 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M994 199.5C994 200.881 992.881 202 991.5 202C990.119 202 989 200.881 989 199.5C989 198.119 990.119 197 991.5 197C992.881 197 994 198.119 994 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1009 199.5C1009 200.881 1007.88 202 1006.5 202C1005.12 202 1004 200.881 1004 199.5C1004 198.119 1005.12 197 1006.5 197C1007.88 197 1009 198.119 1009 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1024 199.5C1024 200.881 1022.88 202 1021.5 202C1020.12 202 1019 200.881 1019 199.5C1019 198.119 1020.12 197 1021.5 197C1022.88 197 1024 198.119 1024 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1039 199.5C1039 200.881 1037.88 202 1036.5 202C1035.12 202 1034 200.881 1034 199.5C1034 198.119 1035.12 197 1036.5 197C1037.88 197 1039 198.119 1039 199.5Z"
                        fill={color2}
                    />
                    <path
                        d="M1054 199.5C1054 200.881 1052.88 202 1051.5 202C1050.12 202 1049 200.881 1049 199.5C1049 198.119 1050.12 197 1051.5 197C1052.88 197 1054 198.119 1054 199.5Z"
                        fill={color2}
                    />
                    <rect y="496" width="899" height="584.161" fill={color2} />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M66.6873 535.097L65.6631 532.895L64.6389 535.097L60.835 535.69L64.6389 536.282L65.6631 538.485L66.6873 536.282L70.4912 535.69L66.6873 535.097ZM66.6873 585.407L65.6631 583.205L64.6389 585.407L60.835 586L64.6389 586.593L65.6631 588.795L66.6873 586.593L70.4912 586L66.6873 585.407ZM65.6631 633.516L66.6873 635.718L70.4912 636.311L66.6873 636.904L65.6631 639.106L64.6389 636.904L60.835 636.311L64.6389 635.718L65.6631 633.516ZM66.6873 686.028L65.6631 683.826L64.6389 686.028L60.835 686.621L64.6389 687.214L65.6631 689.416L66.6873 687.214L70.4912 686.621L66.6873 686.028ZM152.57 532.895L153.594 535.097L157.398 535.69L153.594 536.282L152.57 538.485L151.545 536.282L147.742 535.69L151.545 535.097L152.57 532.895ZM153.594 585.407L152.57 583.205L151.545 585.407L147.742 586L151.545 586.593L152.57 588.795L153.594 586.593L157.398 586L153.594 585.407ZM152.57 633.516L153.594 635.718L157.398 636.311L153.594 636.904L152.57 639.106L151.545 636.904L147.742 636.311L151.545 635.718L152.57 633.516ZM153.594 686.028L152.57 683.826L151.545 686.028L147.742 686.621L151.545 687.214L152.57 689.416L153.594 687.214L157.398 686.621L153.594 686.028ZM239.476 532.895L240.5 535.097L244.304 535.69L240.5 536.282L239.476 538.485L238.452 536.282L234.648 535.69L238.452 535.097L239.476 532.895ZM240.5 585.407L239.476 583.205L238.452 585.407L234.648 586L238.452 586.593L239.476 588.795L240.5 586.593L244.304 586L240.5 585.407ZM239.476 633.516L240.5 635.718L244.304 636.311L240.5 636.904L239.476 639.106L238.452 636.904L234.648 636.311L238.452 635.718L239.476 633.516ZM240.5 686.028L239.476 683.826L238.452 686.028L234.648 686.621L238.452 687.214L239.476 689.416L240.5 687.214L244.304 686.621L240.5 686.028ZM326.383 532.895L327.407 535.097L331.211 535.69L327.407 536.282L326.383 538.485L325.359 536.282L321.555 535.69L325.359 535.097L326.383 532.895ZM327.407 585.407L326.383 583.205L325.359 585.407L321.555 586L325.359 586.593L326.383 588.795L327.407 586.593L331.211 586L327.407 585.407ZM326.383 633.516L327.407 635.718L331.211 636.311L327.407 636.904L326.383 639.106L325.359 636.904L321.555 636.311L325.359 635.718L326.383 633.516ZM327.407 686.028L326.383 683.826L325.359 686.028L321.555 686.621L325.359 687.214L326.383 689.416L327.407 687.214L331.211 686.621L327.407 686.028Z"
                        fill={color1}
                    />
                    <line
                        x1="404.692"
                        y1="1059.76"
                        x2="562.818"
                        y2="871.308"
                        stroke={color1}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <rect
                        x="23"
                        y="345"
                        width="828"
                        height="15"
                        fill={color2}
                    />
                    <circle cx="866" cy="353" r="8" fill={color2} />
                    <line
                        x1="744.692"
                        y1="1182.76"
                        x2="902.818"
                        y2="994.308"
                        stroke={color1}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <g clip-path="url(#clip1_689_1900)">
                        <rect
                            width="53.8848"
                            height="496"
                            transform="translate(899.136 540)"
                            fill={color4}
                        />
                        <rect
                            width="101"
                            height="496"
                            transform="translate(852 540)"
                            fill={color1}
                        />
                    </g>
                    <g clip-path="url(#clip2_689_1900)">
                        <rect
                            width="342.136"
                            height="496"
                            transform="translate(557 540)"
                            fill={color4}
                        />
                        <line
                            x1="514.692"
                            y1="764.755"
                            x2="672.818"
                            y2="576.308"
                            stroke={color2}
                            stroke-width="5"
                            stroke-linecap="round"
                        />
                        <g clip-path="url(#clip3_689_1900)">
                            <rect
                                width="527"
                                height="764"
                                transform="translate(557 540)"
                                fill={color1}
                                fill-opacity="0.4"
                            />
                            <line
                                x1="514.692"
                                y1="764.755"
                                x2="672.818"
                                y2="576.308"
                                stroke={color2}
                                stroke-width="5"
                                stroke-linecap="round"
                            />
                            <line
                                x1="738.692"
                                y1="1110.76"
                                x2="896.818"
                                y2="922.308"
                                stroke={color2}
                                stroke-width="5"
                                stroke-linecap="round"
                            />
                        </g>
                    </g>
                    <circle cx="818.928" cy="1062.72" r="7" fill={color1} />
                    <circle cx="508" cy="987" r="7" fill={color1} />
                    <line
                        x1="750.692"
                        y1="526.472"
                        x2="857.395"
                        y2="399.309"
                        stroke={color1}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <line
                        x1="1017.5"
                        y1="1033.5"
                        x2="1061.5"
                        y2="1033.5"
                        stroke={color3}
                        stroke-width="5"
                        stroke-linecap="round"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M368 1014.5C368 1013.12 366.881 1012 365.5 1012C364.119 1012 363 1013.12 363 1014.5C363 1015.88 364.119 1017 365.5 1017C366.881 1017 368 1015.88 368 1014.5ZM393 1014.5C393 1013.12 391.881 1012 390.5 1012C389.119 1012 388 1013.12 388 1014.5C388 1015.88 389.119 1017 390.5 1017C391.881 1017 393 1015.88 393 1014.5ZM415.5 1012C416.881 1012 418 1013.12 418 1014.5C418 1015.88 416.881 1017 415.5 1017C414.119 1017 413 1015.88 413 1014.5C413 1013.12 414.119 1012 415.5 1012ZM443 1014.5C443 1013.12 441.881 1012 440.5 1012C439.119 1012 438 1013.12 438 1014.5C438 1015.88 439.119 1017 440.5 1017C441.881 1017 443 1015.88 443 1014.5ZM465.5 1012C466.881 1012 468 1013.12 468 1014.5C468 1015.88 466.881 1017 465.5 1017C464.119 1017 463 1015.88 463 1014.5C463 1013.12 464.119 1012 465.5 1012ZM493 1014.5C493 1013.12 491.881 1012 490.5 1012C489.119 1012 488 1013.12 488 1014.5C488 1015.88 489.119 1017 490.5 1017C491.881 1017 493 1015.88 493 1014.5ZM365.5 987C366.881 987 368 988.119 368 989.5C368 990.881 366.881 992 365.5 992C364.119 992 363 990.881 363 989.5C363 988.119 364.119 987 365.5 987ZM393 989.5C393 988.119 391.881 987 390.5 987C389.119 987 388 988.119 388 989.5C388 990.881 389.119 992 390.5 992C391.881 992 393 990.881 393 989.5ZM415.5 987C416.881 987 418 988.119 418 989.5C418 990.881 416.881 992 415.5 992C414.119 992 413 990.881 413 989.5C413 988.119 414.119 987 415.5 987ZM443 989.5C443 988.119 441.881 987 440.5 987C439.119 987 438 988.119 438 989.5C438 990.881 439.119 992 440.5 992C441.881 992 443 990.881 443 989.5ZM465.5 987C466.881 987 468 988.119 468 989.5C468 990.881 466.881 992 465.5 992C464.119 992 463 990.881 463 989.5C463 988.119 464.119 987 465.5 987ZM493 989.5C493 988.119 491.881 987 490.5 987C489.119 987 488 988.119 488 989.5C488 990.881 489.119 992 490.5 992C491.881 992 493 990.881 493 989.5Z"
                        fill={color4}
                    />
                </g>
                <defs>
                    <clipPath id="clip0_689_1900">
                        <rect width="1080" height="1080" fill={color4} />
                    </clipPath>
                    <clipPath id="clip1_689_1900">
                        <rect
                            width="53.8848"
                            height="496"
                            fill={color4}
                            transform="translate(899.136 540)"
                        />
                    </clipPath>
                    <clipPath id="clip2_689_1900">
                        <rect
                            width="342.136"
                            height="496"
                            fill={color4}
                            transform="translate(557 540)"
                        />
                    </clipPath>
                    <clipPath id="clip3_689_1900">
                        <rect
                            width="527"
                            height="764"
                            fill={color4}
                            transform="translate(557 540)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};
